import Vue from 'vue'
import WarehouseTransformer from '../../../transformers/catalog/warehouse/warehouse'

const updateSource = function (source, item, original) {
  if (!source) {
    logError(type)
    return
  }
  const index = source.indexOf(original)
  if (index !== -1) {
    source.splice(index, 1, item)
  } 
}

export default (type, catalog, oldCatalog, config = {}) => {
  const transformed = WarehouseTransformer.send(catalog)

  const id = transformed.id
  const source = config.source

  config.source = null
  const url = `/purchase/${type}/${id}/`
  const request = Vue.$http.put(url, transformed)

  return request.then((response) => {
    let data = response.data
    data = WarehouseTransformer.fetch(data)

    if (source) {
      updateSource(source, catalog, oldCatalog)
    }
    return data
  })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/update.js